import React, { useMemo } from 'react';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxOutlineBlankSharpIcon from '@mui/icons-material/CheckBoxOutlineBlankSharp';
import IndeterminateCheckBoxOutlinedIcon from '@mui/icons-material/IndeterminateCheckBoxOutlined';
type checkboxProp = {
  icon?: JSX.Element;
  checkedIcon?: JSX.Element;
  indeterminateIcon?: JSX.Element;
};

export const useSmartDiaryCheckboxIcons = (): checkboxProp => {
  return useMemo(() => {
    return {
      checkedIcon: <CheckBoxOutlinedIcon />,
      indeterminateIcon: <IndeterminateCheckBoxOutlinedIcon />,
      icon: <CheckBoxOutlineBlankSharpIcon />
    };
  }, []);
};
